$(function(){

  ////////////////////////////////////////
  ///// Product Mini Accordion Start /////
  ////////////////////////////////////////  
  
  $('.PairsWellButton').click(function(e) {
    e.preventDefault();

    var variant_id = $(this).attr('variant_id');
    var variant_img = $(this).attr('variant_image');
    var product_title = $(this).attr('product_title');
    var variant_title = $(this).attr('variant_title');
    
    jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      "id": parseInt($(this).attr('variant_id')),
      "quantity": 1
    },
    dataType: 'json',
    success: function() { 

      $('#cartModalImg').attr('src', variant_img);
      $('#cartModalTitle').html(product_title);
      $('#cartModalVariant').html(variant_title);

      $(".PairsWellATC-Add").fadeOut(function() {
        $('.PairsWellATC-Added').fadeIn(400);
      });
      
      $('.cart-modal').css('visibility','visible');
      $('.cart-modal').css('opacity','1');
      
      jQuery.getJSON('/cart.js', function(cart) { 
        var cart_total = '$' + (cart.total_price / 100).toFixed(2)
        var total_left_for_free_shipping = ((5000 - cart.total_price) / 100).toFixed(2);
        var currency = cart.currency;

        $('.bag-total').html(cart_total);
        
        if (cart.total_price > 5000) { //change here for free shipping amount
          $('.cart-modal-free-shipping').html('Congratulations! You got free shipping and a free full size gift')
        } else {
          $('.cart-modal-free-shipping').html('You are $' + total_left_for_free_shipping + ' away from a free full size gift and free shipping.');
        }
      });
	}
    });
  })
  
  $('.faq-zone-accordion-checkbox').click(function() {
    var current = $(this).attr('id');
    if ($(this).is(':checked')) {
      $('.faq-zone-accordion-checkbox').each(function() {
        if ($(this).attr('id') == current) { $(this).prop('checked', true); } 
        else { $(this).prop('checked', false); }
      })
    } else { $(this).prop('checked', false); }
  });

   if (window.screen.width < 769) {
     $('#features_benefits').prop('checked', false);
     // $('.accordion_tab input').each(function() {
     //     $(this).prop('checked', false);
     // })
   } 

  ////////////////////////////////////////
  ////// Product Mini Accordion End //////
  ////////////////////////////////////////  


  ////////////////////////////////////////
  ///// Product Button Sidebar Start /////
  ////////////////////////////////////////  
  
  $('.shade-finder-btn').click(function(e) {
    e.preventDefault();
    $('.sidebar-shade-finder').toggleClass('open');
    $('.cfx-overlay').toggleClass('open');
    $('body').toggleClass('overflow-hidden');
  });

  $('.ask-our-experts-btn').click(function(e) {
    e.preventDefault();
    $('.sidebar-ask-our-experts').toggleClass('open');
    $('.cfx-overlay').toggleClass('open');
    $('body').toggleClass('overflow-hidden');
  })

  $('.sidebar-shade-finder .close').click(function(e) {
    e.preventDefault();
    $('.sidebar-shade-finder').removeClass('open');
    $('.cfx-overlay').removeClass('open');
    $('body').removeClass('overflow-hidden');
  })
                                          
  $('.sidebar-ask-our-experts .close').click(function(e) {
    e.preventDefault();
    $('.sidebar-ask-our-experts').removeClass('open');
    $('.cfx-overlay').removeClass('open');
    $('body').removeClass('overflow-hidden');
  })
                                          
  $(document).mouseup(function(e) {
    var sidebar_shade_finder = $('.sidebar-shade-finder');
    var sidebar_ask_our_experts = $('.sidebar-ask-our-experts');
    var variant_select_wrapper = $('.variant-select-wrapper');
    var pairs_well_select_wrapper = $('.pairs_well_select_wrapper');
    var sidebar_overaly = $('.cfx-overlay');
    
    if (!sidebar_shade_finder.is(e.target) && sidebar_shade_finder.has(e.target).length === 0) {
      sidebar_shade_finder.removeClass('open');
      if (sidebar_ask_our_experts.hasClass('open')) {} else { sidebar_overaly.removeClass('open'); $('body').removeClass('overflow-hidden');}
      
    }
    if (!sidebar_ask_our_experts.is(e.target) && sidebar_ask_our_experts.has(e.target).length === 0) {
      sidebar_ask_our_experts.removeClass('open');
      if (sidebar_shade_finder.hasClass('open')) {} else { sidebar_overaly.removeClass('open'); $('body').removeClass('overflow-hidden');}
    }

    if (!variant_select_wrapper.is(e.target) && variant_select_wrapper.has(e.target).length === 0) {
      variant_select_wrapper.find('.variant-select').removeClass('open');
    }

    if (!pairs_well_select_wrapper.is(e.target) && pairs_well_select_wrapper.has(e.target).length === 0) {
      pairs_well_select_wrapper.find('.pairs_well_select').removeClass('open');
    }
    
  });
  
  ////////////////////////////////////////
  ////// Product Button Sidebar End //////
  ////////////////////////////////////////  

  
  ////////////////////////////////////////
  //////// Variant Dropdown Start ////////
  ////////////////////////////////////////    

  for (const dropdown of document.querySelectorAll(".variant-select-wrapper")) {
    dropdown.addEventListener('click', function() {
      this.querySelector('.variant-select').classList.toggle('open');
    })
  }

  $('.variant-option').click(function(e) {
    e.preventDefault();
    
    var variant_id = $(this).attr("variant-id");
    var variant_desc = $(this).attr("variant-desc");
    var variant_title = $(this).attr("variant-title");
    var variant_hex = $(this).attr("variant-hex");
    var variant_available = $(this).attr("available");

    $(this).parent().parent().find('.variant_value').html(variant_id);
    $(this).parent().parent().find('.variant_desc').html(variant_desc);
    $(this).parent().parent().find('.selected_variant').css("display", "flex");
    $(this).parent().parent().find('.default_variant').css("display", "none");
    $(this).parent().parent().find('.selected_variant').find('.variant-swatch').css("background-color", variant_hex);
    $(this).parent().parent().find('.variant_title').html(variant_title);
    
    if (variant_available == 'false') {
      $(this).parent().parent().find('.selected_variant .variant_title').css('color', '#979797');
      $(this).parent().parent().find('.selected_variant .variant_title').css('text-decoration', 'line-through');
      $(this).parent().parent().find('.variant_desc').css('color', '#979797');
      $(this).parent().parent().find('.variant_desc').css('text-decoration', 'line-through');
      $('.klaviyo-bis-trigger').css('display', 'block');
      $('.buy-buttons.not-gift-card .button.product-buy-button').css('display', 'none');
    } else {
      $(this).parent().parent().find('.selected_variant .variant_title').css('color', '#202020');
      $(this).parent().parent().find('.selected_variant .variant_title').css('text-decoration', 'none');
      $(this).parent().parent().find('.variant_desc').css('color', '#202020');
      $(this).parent().parent().find('.variant_desc').css('text-decoration', 'none');
      $('.klaviyo-bis-trigger').css('display', 'none');
      $('.buy-buttons.not-gift-card .button.product-buy-button').css('display', 'block');
    }

    $('.variant-picker__option-values .color-swatch').each(function() {
      var color_swatch_title = $(this).attr('title');
      if (color_swatch_title == variant_title) {
        $(this).click();
        return false;
      }
    })
  });

  $('.product-info .color-swatch').click(function(e) {

    var color_swatch_title = $(this).attr('title');
    var color_swatch_description = $(this).attr('description');
    var color_swatch_id = $(this).attr('swatch_id');
    var color_swatch_hex = $(this).attr('hex');
    var color_swatch_image = "url('" + $(this).attr('swatch_image') + "')";
    var color_swatch_availability = $(this).attr('swatch_availability');

    $('.variant_value').html(color_swatch_id);
    $('.variant_desc').html(color_swatch_description);
    $('.selected_variant').css("display", "flex");
    $('.default_variant').css("display", "none");
    if ($(this).attr('swatch_image') != '') {$('.selected_variant').find('.variant-swatch').css("background-image", color_swatch_image);}
    $('.selected_variant').find('.variant-swatch').css("background-color", color_swatch_hex);
    $('.variant_title').html(color_swatch_title);

    if (color_swatch_availability == 'false') {
      $('.buy-buttons.not-gift-card .button.product-buy-button').css('display', 'none');
    } else {
      $('.buy-buttons.not-gift-card .button.product-buy-button').css('display', 'block');
    }
    
    if ($('.product').hasClass('contains-metafields')) {
      $('.product-gallery').each(function() {
        if ($(this).attr('variant') == color_swatch_title) {
          $(this).css("display", "flex");
        } else {
          $(this).css("display", "none");
        }
      })
    }
    
  });

  ////////////////////////////////////////
  ///////// Variant Dropdown End /////////
  //////////////////////////////////////// 
  let sellingplan = '';
  document.addEventListener('click', function(event) {
      if(event.target.id == 'trynow-cta-button'){
          sellingplan = 1103396936;
      }
  })

  $('buy-buttons.not-gift-card .button.product-buy-button').click(function(e) {
    e.preventDefault();
    var current_this = $(this);
    var variant_id = parseInt($('.swatch-input:checked').attr('variant-id'))
    var variant_img = $('.swatch-input:checked').attr('variant-img');
    var product_title = $('.swatch-input:checked').attr('product-title');
    var variant_title = $('.swatch-input:checked').attr('variant-title');
    var default_id = parseInt($(this).parent().attr('variant-id'));
    var default_title = $(this).parent().attr('product-title');
    var default_image = $(this).parent().attr('product-img');
    if (variant_id == null || variant_id == "" || Number.isNaN(variant_id)) { 
      variant_id = default_id;
      variant_img = default_image;
      product_title = default_title;
    }
    
    /* const tnToggle = document.querySelector('.tn-gate-toggle-input').checked;
    const tryNow = document.querySelector('trynow-cta-button').style.display;
    const gatedFlow = document.querySelector('gated-flow-toggle').style.display;

    if (tnToggle && tryNow && tnToggle == true && tryNow == 'unset' && gatedFlow && gatedFlow != 'none'){
      sellingplan = 1103396936;
    } */
    
    jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      "id": variant_id,
      "quantity": 1,
      "selling_plan": sellingplan
    },
    dataType: 'json',
    success: function() { 

    $('#cartModalImg').attr('src', variant_img);
    $('#cartModalTitle').html(product_title);
    $('#cartModalVariant').html(variant_title);
    
    $('.cart-modal').css('visibility','visible');
    $('.cart-modal').css('opacity','1');
    
    jQuery.getJSON('/cart.js', function(cart) {  
      var cart_total = '$' + (cart.total_price / 100).toFixed(2)
      var total_left_for_free_shipping = ((5000 - cart.total_price) / 100).toFixed(2);
      var currency = cart.currency;

      // TryNow Code
      let tryNowTotalPrice = 0;

      cart.items.forEach(function(item) {
        if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan.name.includes('Try')) {
          tryNowTotalPrice += item.final_line_price;
        }
      });

      if(tryNowTotalPrice > 0){
        $('.bag-total').html('$' + ((cart.total_price - tryNowTotalPrice)/100).toFixed(2));
      }else{
        $('.bag-total').html(cart_total);
      }
      // TryNow Code
      
      if (cart.total_price > 5000) { //change here for free shipping amount
        $('.cart-modal-free-shipping').html('Congratulations! You got free shipping and a free full size gift')
      } else {
        $('.cart-modal-free-shipping').html('You are $' + total_left_for_free_shipping + ' away from a free full size gift and free shipping.');
      }
    });
	},
    error: function() {
      current_this.parent().parent().parent().parent().parent().find('.variant-select-wrapper').click();
    }
    });

    sellingplan = "";
    
  })
  
  $('.cart-modal .close').click(function() {
    $('.cart-modal').css('visibility','hidden');
    $('.cart-modal').css('opacity','0');
  })

  $('.cart-modal').mouseup(function(e) {
    var cart_modal_inner = $('.cart-modal-inner');

    if (!cart_modal_inner.is(e.target) && cart_modal_inner.has(e.target).length === 0) {
      $('.cart-modal').css('visibility','hidden');
      $('.cart-modal').css('opacity','0');      
    }
    
  });
})